<template>
	<div>
		<Modal
			:show="showModal"
			@close="closeModal"
			body-classes="m-0 pt-0 pb-0"
			:hideFooter="true"
			footer-classes="pt-0"
			header-classes="pb-1"
			size="lg"
		>
			<template v-slot:header>
				<h5 class="modal-title" id="modalTitle">{{ headerTitle }}</h5>
			</template>

			<b-overlay :show="isLoading" rounded="sm">
				<div class="pt-2">
					<h5 style="flex: auto; text-align: center">
						Upload a new leaderboard item to the app.
					</h5>
					<h6 v-if="errorMessage" style="color: red; flex: auto; text-align: center">
						{{ errorMessage }}
					</h6>
				</div>

				<form ref="form" class="pt-1 pb-1">
					<BaseInput
						label="Name"
						id="title"
						placeholder="Name"
						required
						v-model="leaderboardData.leaderboardTitle"
					/>
					<BaseInput label="Description">
						<textarea
							placeholder="Enter description..."
							v-model="leaderboardData.leaderboardDescription"
							class="form-control"
							id="description"
							rows="6"
							required
						></textarea>
					</BaseInput>
                    <BaseInput
						label="Points"
						id="points"
						placeholder="Points"
                        type="number"
						required
						v-model="leaderboardData.leaderboardPoints"
					/>
                    <BaseInput
						label="Expiration Date"
						id="expiration"
						placeholder="Expiration Date"
                        type="datetime-local"
						v-model="leaderboardData.expiresAt"
					/>
                    <BaseInput
						label="Max Usage Per User"
						id="usage"
						placeholder="Max Usage Per User"
                        type="number"
						required
						v-model="leaderboardData.scanLimitPerUser"
					/>
                    <b-row class="mt-2">
						<b-col cols="auto" class="mr-auto">
							<label class="form-control-label">Is Item Active?</label>
						</b-col>
						<b-col cols="auto">
							<BaseSwitch
								v-model="leaderboardData.leaderboardIsActive"
							></BaseSwitch>
						</b-col>
					</b-row>
					<ButtonRadioGroup v-if="dataSets"
						label="Select Conference"
						:options="dataSets"
						v-model="leaderboardData.dataSet"/>

					<b-row class="mr-0 mt-3 mb-3">
						<div style="flex-grow: 1"></div>
						<base-button
							type="primary"
							:loading="isLoading"
							:shake="shake"
							@click="submit"
							>Add Item & Generate QR Code</base-button
						>
					</b-row>
				</form>
			</b-overlay>
		</Modal>
	</div>
</template>
<script>
import { collection, doc, setDoc } from '@firebase/firestore';
import ButtonRadioGroup from '../../components/ButtonRadioGroup.vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { mapGetters } from 'vuex';
import BaseInput from '../../components/Inputs/BaseInput.vue';
import Modal from '../../components/Modals/Modal.vue';
import {
	getOrganizationFirestore
} from '../../resources/organizationFirebase';
import BaseSwitch from '../../components/BaseSwitch.vue';

export default {
	components: { Modal, BaseInput, BaseSwitch, ButtonRadioGroup },
	computed: {
		...mapGetters({
			organization: 'getOrganization',
			dataSets: 'getDataSets'
		}),
	},
	props: {
		headerTitle: {
			type: String,
			default: 'New Leaderboard Item',
		},
		showModal: {
			type: Boolean,
			default: false,
		},
		editLeaderboardData: {
			type: Object,
			default: null,
		},
	},
	watch: {
		editLeaderboardData: {
			handler(val) {
				if (val) {
					this.leaderboardData.leaderboardTitle = val.leaderboardTitle;
					this.leaderboardData.leaderboardDescription = val.leaderboardDescription;
                    this.leaderboardData.leaderboardPoints = val.leaderboardPoints;
                    this.leaderboardData.leaderboardIsActive = val.leaderboardIsActive;
                    this.leaderboardData.scanLimitPerUser = val.scanLimitPerUser;
                    if (val.expiresAt){
                        console.log(val.expiresAt)
                        const date = val.expiresAt.toDate()
                        this.leaderboardData.expiresAt = this.$helpers.formatDate(date,
						'yyyy-MM-dd\'T\'HH:mm')
                    }
					return;
				} else {
					return this.resetView();
				}
			},
			deep: true,
		},
	},
	data() {
		return {
			shake: false,
			isLoading: false,
			leaderboardData: {
				leaderboardTitle: null,
				leaderboardDescription: null,
				leaderboardPoints: null,
                leaderboardIsActive: true,
                expiresAt: null,
                scanLimitPerUser: 1,
				dataSet: null,
			},
			errorMessage: null,
		};
	},
	methods: {
		resetView() {
			this.leaderboardData.leaderboardTitle = null;
			this.leaderboardData.leaderboardDescription = null;
			this.leaderboardData.leaderboardPoints = null;
			this.leaderboardData.leaderboardIsActive = true;
            this.leaderboardData.expiresAt = null;
            this.leaderboardData.scanLimitPerUser = 1;
		},
		closeModal() {
			this.$emit('update:show', false);
			this.$emit('close');
		},
		submit() {
			this.shake = false;

			const leaderboardTitle = this.leaderboardData.leaderboardTitle;
			const leaderboardDescription = this.leaderboardData.leaderboardDescription;
            const leaderboardPoints = this.leaderboardData.leaderboardPoints;

			const dataSet = this.leaderboardData.dataSet;

			if (
				this.$helpers.isBlank(leaderboardTitle) ||
				this.$helpers.isBlank(leaderboardDescription) ||
                this.$helpers.isBlank(leaderboardPoints)
			) {
				this.errorMessage = 'Please complete all the necessary fields.';
				this.shake = true;
				return;
			} else if (this.dataSets && this.$helpers.isBlank(dataSet)){
				this.errorMessage = 'Please select a conference.';
				this.shake = true;
				return;
			} else {
				this.errorMessage = null;

				const firestore = getOrganizationFirestore(this.organization);
				const leaderboardRef = collection(firestore, 'leaderboard');

				var leaderboardIdRef = null;

				if (this.editLeaderboardData != null) {
					leaderboardIdRef = doc(
						firestore,
						`${leaderboardRef.path}/${this.editLeaderboardData.leaderboardId}`
					);
					this.sendDataToFirebase(leaderboardIdRef);
				} else {
					leaderboardIdRef = doc(leaderboardRef);
                    this.sendDataToFirebase(leaderboardIdRef)
				}

				this.isLoading = true;
			}
		},
		sendDataToFirebase(leaderboardIdRef) {
			const leaderboardId = leaderboardIdRef.id;
            
            var data = {
                leaderboardId: leaderboardId,
				leaderboardTitle: this.leaderboardData.leaderboardTitle,
				leaderboardDescription: this.leaderboardData.leaderboardDescription,
				leaderboardPoints: parseInt(this.leaderboardData.leaderboardPoints),
                leaderboardIsActive: this.leaderboardData.leaderboardIsActive,
                createdVia: 'adminPortal',
                scanLimitPerUser: parseInt(this.leaderboardData.scanLimitPerUser)
			}

            if (this.leaderboardData.expiresAt){
                data["expiresAt"] = new Date(this.leaderboardData.expiresAt)
            }

			if (this.leaderboardData.dataSet){
				data['dataSet'] = this.leaderboardData.dataSet
			}

			setDoc(leaderboardIdRef, data, { merge: true })
				.then(() => {
					this.isLoading = false;
					this.$emit('newLeaderboardItem', data);

					this.closeModal();
					this.resetView();
				})
				.catch((error) => {
					this.isLoading = false;
					this.errorMessage = error.message;
					this.shake = true;
				});
		},
		isEmpty(str) {
			return this.$helpers.isBlank(str);
		},
	},
};
</script>
